import { assoc, assocPath, compose, path, pick } from 'ramda'
import { sessionState } from '@btime/react-session'

import { parseEntitiesResult } from './parsers/entity'
import { sendFailedLog, sendLog } from './log'
import axios from 'axios'

// TODO: Move to logs core
export const sendLogFromApolloLink = async (operation, result, opts = {}) => {
  const queryName = operation.operationName
  const queryType = path(['query', 'definitions', 0, 'operation'], operation)
  const context = operation.getContext()
  const happenedAt = context.happenedAt
  const executionTime = context.executionTime
  const requestId = context.headers?.requestId
  const workspace = context.headers?.workspace
  const res = await axios.get('https://api.ipify.org?format=json').catch(() => {})
  const tags = {
    api: 'v2',
    tool: 'apollo/link',
    env: process.env.NODE_ENV,
    ip: res?.data?.ip
  }
  const user = pick(['id', 'email', 'name'], sessionState.user || {})

  if (!['mutation', 'query'].includes(queryType)) return false
  try {
    const isMutation = queryType === 'mutation'
    let level = isMutation ? 'info' : 'monitor'

    if (!!result?.errors) level = 'error'

    const name = queryType + queryName

    let data = {
      ...(pick(['status', 'url'], context.response || {}) || {}),
      ...(pick(['errors'], result) || {}),
      payload: {
        queryName,
        query: `${operation?.query?.loc?.source?.body}`,
        variables: operation.variables
      }
    }

    let logData = {
      happenedAt,
      requestId,
      workspace,
      user,
      level,
      name,
      data,
      executionTime,
      tags
    }

    if (isMutation) {
      logData = compose(
        assocPath(['data', 'result'], result),
        assoc('entities', parseEntitiesResult(result, operation.variables, queryName))
      )(logData)
    }

    return sendLog(logData).catch(error => {
      console.warn(error)
      sendFailedLog({
        user,
        queryType,
        queryName,
        executionTime,
        workspace,
        error
      }).catch(e => console.warn('Não foi possível enviar logs para o servidor', e))
    })
  } catch (error) {
    console.warn(error)
    sendFailedLog({
      user,
      queryType,
      queryName,
      executionTime,
      workspace,
      error
    })
  }
}
